import { Home,  MessageSquare } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const SideBarMobile = () => {
  const location = useLocation();

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <nav className="navbar-bottom">
      <div className="navbar-mobile navbar-visible">
        <ul className="navbar-links flex-row align-items-center space-around">
          <li>
            <Link to="/dashboard" className="flex-row-align">
              <Home color={isActive('/dashboard') ? '#ffffff' : '#9ca3af'} />
            </Link>
          </li>
          {/* <li>
            <Link to="/dashboard/gallery" className="flex-row-align">
              <Briefcase color={isActive('/dashboard/gallery') ? '#ffffff' : '#9ca3af'} />
            </Link>
          </li> */}
          <li>
            <Link to="/dashboard/support" className="flex-row-align">
              <MessageSquare color={isActive('/dashboard/support') ? '#ffffff' : '#9ca3af'} />
            </Link>
          </li>
          {/* <li>
            <Link to="/dashboard/settings" className="flex-row-align">
              <Settings color={isActive('/dashboard/settings') ? '#ffffff' : '#9ca3af'} />
            </Link>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default SideBarMobile;
